module.exports = __webpack_public_path__ + "img/CCLF_infographic-18.953f2849.png";